// The public demo's copy (spec/24) — the `demo` namespace. Loaded by the console's demo build and the kiosk's demo
// build alone, through `@clavian/i18n/demo`, so the console at `app.{domain}` and the station's kiosk never carry it.
//
// The voice is BRAND.md §6's: say what happens, plainly; a control says exactly what it does. The words are the
// glossary's: venue, station, PC, session, player — never "terminal", "machine" or "seat". Times are filled in by the
// caller (`{{time}}` a countdown, `{{when}}` a date and time in the visitor's own clock).
export const demo = {
    // The landing page at demo.{domain}/ (spec/24 §4.1).
    welcome: {
        documentTitle: 'Clavian demo',
        eyebrow: 'Live demo',
        title: 'See Clavian run a gaming café',
        intro: 'Clavian runs gaming venues: the PCs, the time on them, the food and the money. Try the staff console and the screen a player sees on the PC, on a pretend café called Demo Arena, for 15 minutes.',
        points: {
            console: 'The floor of PCs, the sessions on them, the kitchen and the players: what staff see behind the counter.',
            kiosk: 'What a player sees on the PC: signing in, the time they have left, ordering food.',
            together: 'Open both at once. A player who signs in at the kiosk shows up on the console’s floor straight away.',
        },
        // The decorative glimpse of Demo Arena's floor beside the title.
        preview: {
            floor: 'Floor',
            live: 'Live',
        },
        pretend: 'Everything in the demo is made up. Nothing you do reaches a real venue, and nobody is charged or messaged.',
        tryConsole: 'Try the staff console',
        tryKiosk: 'Try the kiosk',
        tryBoth: 'Both, side by side',
        desktopNote: 'Made for a computer screen. On a phone, open this page on a computer to try it.',
        signedOut: 'Sign in with your Clavian account to start. Making one takes a minute.',
        signIn: 'Sign in',
        createAccount: 'Create an account',
        signedInAs: 'Signed in as {{name}}.',
        signOut: 'Sign out',
        notStarted: 'Your 15-minute demo starts when you open the console or the kiosk.',
        running: 'Your demo is running: {{time}} left.',
        ended: 'Your demo has ended. You can start another after {{when}}.',
        endedCanRestart: 'Your last demo has ended. Opening the console or the kiosk starts a new one.',
        loading: 'Checking your demo',
        unavailable: 'The demo could not be reached just now. Try again in a moment.',
        retry: 'Try again',
    },
    // The bar across the top of the console and the kiosk while a demo runs (spec/24 §4.3).
    banner: {
        region: 'Demo',
        label: 'Demo · {{time}} left',
        reset: 'Reset demo',
        resetDone: 'The demo venue is back to how it opened.',
        openKiosk: 'Open the kiosk',
        openConsole: 'Open the console',
        home: 'Demo home',
        pc: 'This screen is {{pc}}',
        changePc: 'Change PC',
        tip: 'Sign in as {{quick}} for a 5-minute session, or as {{long}} for a longer one. The password is {{password}}.',
    },
    // The end (spec/24 §4.3).
    ended: {
        title: 'Your 15-minute demo has ended',
        body: 'Thanks for trying Clavian. Demo Arena has closed for you, and nothing you did there was kept.',
        next: 'You can start another demo after {{when}}.',
        nextNow: 'You can start another demo now.',
        startAgain: 'Start a new demo',
        home: 'Back to the demo home',
        contact: 'Want to see Clavian at your venue? Write to {{email}}.',
    },
    // Before the demo can show anything.
    gate: {
        loading: 'Getting the demo ready',
        signInTitle: 'Sign in to try the demo',
        signInBody: 'The demo is open to anyone with a Clavian account. Sign in, or make an account first.',
        error: 'The demo could not start. Try again in a moment.',
        retry: 'Try again',
    },
    // The kiosk asks which PC it is (spec/24 §4.4).
    picker: {
        title: 'Which PC is this?',
        intro: 'Pick one of Demo Arena’s PCs. This screen becomes its kiosk, and the console shows what happens on it.',
        free: 'Free',
        inSession: 'In session',
        locked: 'Screen locked',
        suggested: 'Free — a good one to start with',
        use: 'Use {{pc}}',
        smallScreen: 'The kiosk is made for a PC’s screen. It works best on a computer.',
    },
    // The landing page's side-by-side view (spec/24 §4.1).
    both: {
        title: 'Console and kiosk',
        console: 'Staff console',
        kiosk: 'Kiosk',
    },
};
export default demo;
//# sourceMappingURL=demo.js.map